import _ from 'lodash';
import Alert from 'react-s-alert';
import qs from 'qs';
const Dls = {
    success(message) {
        Alert.success(message, {
            position: 'bottom-right',
            beep: false,
            timeout: 3000
        });
    },
    error(message) {
        Alert.error(message, {
            position: 'bottom-right',
            beep: false,
            timeout: 'none'
        });
    },
    info(message) {
        Alert.info(message, {
            position: 'bottom-right',
            beep: false,
            timeout: 'none'
        })
    },
    apiErrorAlert({response}) {
        const {data, status} = response;
        if (status === 401) {
            this.error('You are not authorized to do this');
        } else if (status === 400) {
            if (_.isObject(data) && data.data) {
                this.error(data.data)
            } else {
                this.error('An unexpected error has occurred')
            }
        } else {
            this.error(`An unexpected error has occurred: ${_.isObject(data) ? data.data : null}`)
        }
    },
    apiErrorMessage({response}) {
        const messages = [];
        const {data, status} = response;

        if (status === 422) {
            //Form validation error
            const {errors} = data;
            if (_.isObject(errors)) {
                _.each(errors, (value,key) => {
                    if (_.isString(value)) {
                        messages.push(value);
                    }
                    if (_.isArray(value)) {
                        _.each(value, (message, key) => {
                            messages.push(message);
                        })
                    }
                })
            } else {
                messages.push("Your input(s) are not valid");
            }
        } else if(status === 401) {
            messages.push("Your credential is not valid");
        } else if (status === 400) {
            const data = response.data;
            if (_.isObject(data) && data.data) {
                messages.push(data.data);
            }
        } else {
            messages.push("There's a server error, please contact support for help.");
            if (_.isObject(data)) {
                messages.push(data.data);
            }
        }

        return messages;
    },

    pagination: {
        inventories() {
            return qs.stringify({
                on_page: 1,
                per_page: 15,
                search: '',
                filters: {
                    type: 'Inventory,Service,Others',
                    status: 'Active'
                },
                order_by: {
                    name: 'asc'
                }
            });
        },

        relations(type) {
            return qs.stringify({
                on_page: 1,
                per_page: 15,
                search: '',
                filters: {
                    type: type,
                    status: 'Active',
                    relation_id: 'All',
                    assigned_to: 'All'
                },
                order_by: {
                    company_name: 'asc'
                }
            });
        },

        orders(type) {
            return qs.stringify({
                on_page: 1,
                per_page: 15,
                search: '',
                filters: {
                    type: type,
                    status: 'Open,Finalized,Hold,Pending,Back Ordered',
                    relation_id: 'All',
                    assigned_to: 'All',
                    warehouse_id: 'All'
                },
                order_by: {
                    so: 'desc'
                }
            });
        },

        shipments(type) {
            return qs.stringify({
                type: type,
                on_page: 1,
                per_page: 15,
                search: '',
                filters: {
                    status: 'Pending,Shipped',
                    warehouse_id: 'All'
                },
                order_by: {
                    created_at: 'desc'
                }
            });
        },

        transactions() {
            return qs.stringify({
                in_qb: 1,
                on_page: 1,
                per_page: 15,
                search: '',
                filters: {
                    acct_type: 'All'
                },
                order_by: {
                    updated_at: 'desc'
                }
            });
        },

        users() {
            return qs.stringify({
                on_page: 1,
                per_page: 15,
                search: '',
                filters: {
                    role: 'Admin,User'
                },
                order_by: {
                    name: 'asc'
                }
            });
        },

        warehouses() {
            return qs.stringify({
                on_page: 1,
                per_page: 15,
                search: '',
                filters: {
                    status: 'Active'
                },
                order_by: {
                    label: 'asc'
                }
            });
        },

        integrationLogs() {
            return qs.stringify({
                on_page: 1,
                per_page: 15,
                order_by: {
                    created_at: 'desc'
                }
            })
        },

        sprProducts() {
            return qs.stringify({
                page: 1,
                search: "",
                shopify: "na",
                spr: "na"
            })
        }
    },

    model: {
        return(shipment) {
            const lines = [];
            _.each(shipment.lines, line => {
                lines.push({
                    uid: line.id,
                    inventory_id: line.inventory_id,
                    qty: "1",
                    original_qty: Math.abs(line.quantity),
                    inventory: line.inventory
                })
            })
            return {
                header: {
                    reference: _.isObject(shipment.order) ? `[RT] ${shipment.order.reference}` : "",
                    po: _.isObject(shipment.order) ? `${shipment.order.po}` : "",
                    bill_to: shipment.bill_to,
                    ship_to: shipment.ship_to
                },
                lines: lines
            }
        },
        shipment(lines, warehouseId, billTo, shipTo) {
            const linesArray = [];
            _.each(lines, line => {
                let qty = parseInt(line.quantity);
                if (line.inventory.type === 'Inventory') {
                    linesArray.push({
                        order_line_id: line.id,
                        quantity: _.isNaN(qty - line.processed) ? "0" : Math.abs(qty) - Math.abs(line.processed),
                        ordered: qty,
                        processed: line.processed,
                        inventory: line.inventory
                    });
                } else {
                    linesArray.push({
                        order_line_id: line.id,
                        quantity: 1,
                        ordered: qty,
                        processed: 'NA',
                        inventory: line.inventory
                    });
                }
            });
            return {
                header: {
                    warehouse_id: warehouseId,
                    bill_to: billTo,
                    ship_to: shipTo,
                    tracking_company: "",
                    tracking_number: "",
                    isDropShip: false,
                    dropShipFrom: ""
                },
                lines: linesArray,
                comment: ""
            }
        }
    }
}

export default Dls;


// WEBPACK FOOTER //
// ./src/lib.js